<template>
	<div>
		<router-link :to="pageUrl">{{title}}</router-link>
		<a @click="openInNewTab(pageUrl)"><i class="far fa-window-restore newtab"/></a>
	</div>
</template>
<script>
export default {
  name: 'AMenuItem',
  props: {
    pageUrl: {
      type: String,
		},
		title: {
			type: String,
		}
	},
  methods: {
		openInNewTab(pageUrl) {
			event.stopImmediatePropagation();
			window.open(pageUrl, '_blank');
		},
	}
}

</script>
<style lang="scss">
.newtab {
	font-size: 15px;
	margin: 0 0 10px 5px;
}
</style>